module.exports = __webpack_public_path__ + "img/bul_arr_left.972c3791.svg";